<script setup>
import {onMounted, ref, watch, defineProps, defineEmits} from "vue";
import useSharedData from "@/use/SharedData.js";
import axios from "axios";
import {useRoleStore} from "@/stores/Role";

const props = defineProps({
    value: [Number, Array],
    readonly: Boolean,
    disabled: Boolean,
    label: String,
    rules: Array,
    multiple: Boolean,
});

const emit = defineEmits(["input"]);

const {loading, inputColor, inputBackgroundColor} = useSharedData();
const roleStore = useRoleStore();

const role = ref(null);

function findAll() {
    loading.value = true;
    axios.get(`/roles`).then(response => {
        roleStore.setRoles(response.data);
    }).finally(() => {
        loading.value = false;
    });
}

function input(value) {
    emit('input', value)
}

watch(() => props.value, () => {
    role.value = props.value;
}, {immediate: true});

onMounted(() => findAll());
</script>

<template>
    <div>
        <v-autocomplete
            v-model="role"
            :items="roleStore.roles"
            item-value="id"
            item-text="name"
            outlined
            dense
            :label="label"
            :color="inputColor"
            :background-color="inputBackgroundColor"
            :readonly="readonly"
            :disabled="disabled"
            :multiple="multiple"
            :loading="loading"
            :clearable="!readonly"
            @input="input"
            :rules="rules"
            hide-details="auto"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>